"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCSSKeys = void 0;
function generateCSSKeys(options) {
    const cssKeys = { ...options };
    const logoKeys = ['light-logo', 'dark-logo'];
    logoKeys.forEach((key) => {
        if (options && options[key] && !options[key].startsWith('url(')) {
            cssKeys[key] = `url('${options[key]}')`;
        }
    });
    return cssKeys;
}
exports.generateCSSKeys = generateCSSKeys;
//# sourceMappingURL=html.js.map